module.exports = __webpack_public_path__ + "img/bugoro_06.e6ae6f78.png";